import * as React from 'react';

type UseOptimisticFilenameSaveParams = {
    filename: string;
    onSave: (newFilename: string) => Promise<any>;
};

export function useOptimisticFilenameSave({ filename, onSave }: UseOptimisticFilenameSaveParams) {
    let [optimisticFilename, setOptimisticFilename] = React.useState<string | null>(null);
    let [saveError, setSaveError] = React.useState(false);

    React.useEffect(
        function resetOnNavigateToDifferentImage() {
            setOptimisticFilename(null);
            setSaveError(false);
        },
        [filename]
    );

    let displayedFilename = optimisticFilename !== null ? optimisticFilename : filename;

    function saveFilename(newFilename: string) {
        setOptimisticFilename(newFilename);
        setSaveError(false);

        onSave(newFilename).catch(function () {
            setOptimisticFilename(null);
            setSaveError(true);
        });
    }

    function dismissSaveError() {
        setSaveError(false);
    }

    return {
        displayedFilename,
        saveError,
        dismissSaveError,
        saveFilename
    };
}
